import fetch from 'auth/FetchInterceptor'

const examService = {}
const domain = 'engineering'

examService.getExams = function (domain) {
  return fetch({
    url: `/domain/${domain}/exams`,
    method: 'get',
    params: {},
    cache: true
  })
}

examService.getAttemptedExams = function () {
  return fetch({
    url: `/attempt/exams`,
    method: 'get',
    params: {},
    cache: true
  })
}

examService.getAllExams = function () {
  return fetch({
    url: `/domain/exams`,
    method: 'get',
    params: {},
    cache: true
  })
}

examService.getSubjectQuestions = function({examId, subjectId, topicId}) {
  return fetch({
    url: `/subject/${examId}/${subjectId}/${topicId}/questions`,
    method: 'get',
    params: {},
    cache: true
  })
}

examService.createExam = function (data) {
    return fetch({
      url: `/exam/${domain}`,
      method: 'post',
      data,
      cache: false
    })
}

examService.getExamSessions = function ({examId}) {
    return fetch({
        url: `/exam/${examId}/sessions`,
        method: 'get',
        params: {},
        cache: true
    })
}

examService.createExamSubject = function (data) {
  return fetch({
    url: `/subject/${data.examId}`,
    method: 'post',
    data,
    cache: false
  })
}

examService.createExamTopic = function (data) {
  return fetch({
    url: `/subject/${data.examId}/${data.subjectId}`,
    method: 'post',
    data,
    cache: false
  })
}

export default examService 